import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { ImageSlotProvider } from './contexts/ImageSlotContext';
import { Layout } from './components/layout/Layout';
import { Home } from './pages/Home';
import { Courses } from './pages/Courses';
import { CourseDetail } from './pages/CourseDetail';
import { CcwPermits } from './pages/CcwPermits';
import { WomensTraining } from './pages/WomensTraining';
import { NraUscca } from './pages/NraUscca';
import { Packages } from './pages/Packages';
import { PrivateTraining } from './pages/PrivateTraining';
import { About } from './pages/About';
import { Reviews } from './pages/Reviews';
import { Faq } from './pages/Faq';
import { Contact } from './pages/Contact';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { Legal } from './pages/Legal';
import { NotFound } from './pages/NotFound';
interface AppProps {
  heroHeadline?: 'train-like-your-life' | 'real-world-defense';
  showImageSlotLabels?: boolean;
}
export function App({
  heroHeadline = 'train-like-your-life',
  showImageSlotLabels = false
}: AppProps) {
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3rcj5s04xxv5k">
      <ImageSlotProvider showLabels={showImageSlotLabels} data-id="element-1" data-mp="3rdkie91luppe">
        <BrowserRouter data-id="element-2" data-mp="5or2zhbcs60">
          <Routes data-id="element-3" data-mp="4wvvprmowg9">
            <Route element={<Layout data-id="element-5" data-mp="56lhc8rh1lf" />} data-id="element-4" data-mp="5gel8p3rovc">
              <Route index element={<Home heroHeadline={heroHeadline} data-id="element-7" data-mp="2zllcouynw8jk" />} data-id="element-6" data-mp="2zl3bdjx5744s" />
              <Route path="courses" element={<Courses data-id="element-9" data-mp="33mf25srr5vek" />} data-id="element-8" data-mp="2zn6actg9w7ln" />
              <Route path="courses/:slug" element={<CourseDetail data-id="element-11" data-mp="33myjb79kwfrj" />} data-id="element-10" data-mp="33nq73vwxp979" />
              <Route path="ccw-permits" element={<CcwPermits data-id="element-13" data-mp="38kqgafp2ys2l" />} data-id="element-12" data-mp="38m1elzzrb7mb" />
              <Route path="womens-training" element={<WomensTraining data-id="element-15" data-mp="3dle1gkqmoeow" />} data-id="element-14" data-mp="38nunzn1r85y0" />
              <Route path="nra-uscca" element={<NraUscca data-id="element-17" data-mp="3dii3wxiozs0z" />} data-id="element-16" data-mp="3dlnwimqj5c1g" />
              <Route path="packages" element={<Packages data-id="element-19" data-mp="nur948fv0n11" />} data-id="element-18" data-mp="nw2a60hx7gog" />
              <Route path="private-training" element={<PrivateTraining data-id="element-21" data-mp="su43rfcz2ye6" />} data-id="element-20" data-mp="nxn4pq48izmb" />
              <Route path="about" element={<About data-id="element-23" data-mp="swgk5o3310p4" />} data-id="element-22" data-mp="st2g8bersjfk" />
              <Route path="reviews" element={<Reviews data-id="element-25" data-mp="356ttacz3qbp" />} data-id="element-24" data-mp="35yq6nee9s31" />
              <Route path="faq" element={<Faq data-id="element-27" data-mp="3uct0lbuzo8ws" />} data-id="element-26" data-mp="38kwkjpju1jo" />
              <Route path="contact" element={<Contact data-id="element-29" data-mp="3uc9jfxd5xojt" />} data-id="element-28" data-mp="3udkmfuysas9v" />
              <Route path="blog" element={<Blog data-id="element-31" data-mp="d57h17dyqql6" />} data-id="element-30" data-mp="3uf5gzkl3mb7q" />
              <Route path="blog/:slug" element={<BlogPost data-id="element-33" data-mp="d2l8b4fc651d" />} data-id="element-32" data-mp="d3cu5nj4soeg" />
              <Route path="refund-policy" element={<Legal slug="refund-policy" data-id="element-35" data-mp="86w7kxrkyi3h" />} data-id="element-34" data-mp="85ujnspgu14c" />
              <Route path="privacy-policy" element={<Legal slug="privacy-policy" data-id="element-37" data-mp="3gkl6xsz04y2b" />} data-id="element-36" data-mp="3gle7gc7darc0" />
              <Route path="terms" element={<Legal slug="terms" data-id="element-39" data-mp="3bmjo995hn0rd" />} data-id="element-38" data-mp="3gja2rs1n9oao" />
              <Route path="*" element={<NotFound data-id="element-41" data-mp="3bk718hkvi07g" />} data-id="element-40" data-mp="3bnmjtudr9rdm" />
            </Route>
          </Routes>
        </BrowserRouter>
      </ImageSlotProvider>
    </MotionConfig>;
}